/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ValidateKeyOrganization = {
  /**
   * The ID of the organization
   */
  id: string;
  /**
   * The name of the organization
   */
  name: string;
  /**
   * The slug of the organization
   */
  slug: string;
};

/** @internal */
export const ValidateKeyOrganization$inboundSchema: z.ZodMiniType<
  ValidateKeyOrganization,
  unknown
> = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
});

export function validateKeyOrganizationFromJSON(
  jsonString: string,
): SafeParseResult<ValidateKeyOrganization, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ValidateKeyOrganization$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ValidateKeyOrganization' from JSON`,
  );
}
